export const SET_SELECTION = 'SET_SELECTION'
export const SET_FLOW = 'SET_FLOW'
export const CLEAR_FLOW = 'CLEAR_FLOW'
export const SET_RESISTANCE_FACTOR = 'SET_RESISTANCE_FACTOR'
export const SET_AMBIENT = 'SET_AMBIENT'
export const FETCH_AUDIO_STREAM = 'FETCH_AUDIO_STREAM'
export const SET_TESTING_FOR = 'SET_TESTING_FOR'